import { render, staticRenderFns } from "./AgregarObservacion.vue?vue&type=template&id=5d38afb2"
import script from "./AgregarObservacion.vue?vue&type=script&lang=js"
export * from "./AgregarObservacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports